import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Injector, NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import {
  HttpXhrBackend,
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';

// import { ModalModule } from 'ngx-bootstrap/modal'; // Commented - not Ivy compatible

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SigninComponent } from './common/signin/signin.component';

import {
  LoadingSpinnerComponent,
  InputComponent,
  ButtonComponent,
  SelectComponent,
  ToastContainerComponent,
  providePreventNumberInputScroll,
} from '@packages/ng-shared-ui';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouteDataProvider } from './shared/providers/RouteDataProvider.provider';
import { AuthGuardService } from './services/auth/auth-guard.service';
import { AuthenticationCheckService } from './services/auth/authentication-check.service';

import { HttpConfigInterceptor } from './services/interceptor/http-loading-interceptor';
import { ToastService } from '@packages/ng-shared-services';
import { UploadZipService } from './services/upload-zip/upload-zip.service';

@NgModule({
  declarations: [
    AppComponent,
    SigninComponent,
    // UploadExcelDetailsComponent, // Excluded - requires Node.js polyfills
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    LoadingSpinnerComponent,
    InputComponent,
    ButtonComponent,
    SelectComponent,
    ToastContainerComponent,
    // NgxUiLoaderModule, // Excluded - not compatible with Angular 19
    // ModalModule.forRoot(), // Commented - not Ivy compatible
  ],
  providers: [
    providePreventNumberInputScroll(),
    provideHttpClient(withInterceptorsFromDi()),
    ToastService,
    RouteDataProvider,
    AuthGuardService,
    AuthenticationCheckService,
    DatePipe,
    // ExportExcelService, // Excluded - requires Node.js polyfills
    UploadZipService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
